import db from "@/database";

export const getFile = (url) => {
  return db.images.get(url);
};
